let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let dateformat = require("ES/lib/dateformat");
let FormUtils = require("../../../../../utils/FormUtils");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");

let incomingPlanToSummaryMessage = function(incoming_plan){
	let n_hotels = _.size(incoming_plan.Hotel);
	let n_flights = _.size(incoming_plan.Flight);
	let n_grounds = _.size(incoming_plan.Ground);
	let parts = [];
	if(n_flights > 0){
		parts.push(n_flights + " Flight" + (n_flights > 1 ? "s" : ""));
	}
	if(n_grounds > 0){
		parts.push(n_grounds + " Ground travel");
	}
	if(n_hotels > 0){
		parts.push(n_hotels + " Hotel" + (n_hotels > 1 ? "s" : ""));
	}

	if(parts.length >= 3){
		return _.take(parts, 2).join(", ") + " and " + _.last(parts);
	}else if(parts.length == 2){
		return parts.join(" and ");
	}else if(parts.length == 1){
		return _.first(parts);
	}
	return "";
};

let incomingPlanToOverwriteMessage = function(incoming_plan){
	let n_hotels = _.size(incoming_plan.Hotel);
	let n_flights = _.size(incoming_plan.Flight);
	let n_grounds = _.size(incoming_plan.Ground);
	let parts = [];
	if(n_flights > 0){
		parts.push(" Flight");
	}
	if(n_grounds > 0){
		parts.push(" Ground travel");
	}
	if(n_hotels > 0){
		parts.push(" Hotel");
	}

	if(parts.length >= 3){
		return _.take(parts, 2).join(", ") + " and " + _.last(parts);
	}else if(parts.length == 2){
		return parts.join(" and ");
	}else if(parts.length == 1){
		return _.first(parts);
	}
	return "";
};

let ApplyIncomingPlan = dd.createClass({
	getInitialState(){
		return {clear_current: false};
	},
	__onChange(e){
		this.setState({clear_current: !!e.target.checked});
	},
	__applyIncomingPlan: esUtils.wrapPreventDefault(function(){
		let event = _.cloneDeep(this.props.event);
		let clear_current = this.state.clear_current;
		let {onClose, id, incoming_plan} = this.props;

		if (incoming_plan.type === 'flight') {
			if (clear_current || !_.isArray(event['Flight'])) {
				event['Flight'] = [];
			}
			event['Flight'] = event['Flight'].concat(_.map(incoming_plan.data.Flight, esUtils.convertBalboa3ToJS['Flight']));
		} else if (incoming_plan.type === 'carRental') {
			if (clear_current || !_.isArray(event['Ground'])) {
				event['Ground'] = [];
			}
			event['Ground'] = event['Ground'].concat(_.map(incoming_plan.data.Ground, esUtils.convertBalboa3ToJS['Ground']));
		} else if (incoming_plan.type === 'hotelReservation') {
			if (clear_current || !_.isArray(event['Hotel'])) {
				event['Hotel'] = [];
			}
			event['Hotel'] = event['Hotel'].concat(_.map(incoming_plan.data.Hotel, esUtils.convertBalboa3ToJS['Hotel']));
		}
		event.tripitID = id;
		radio("save_Event").broadcast(event);
		onClose();
	}),
	render(){
		let {onClose, incoming_plan} = this.props;

		return  Modal({
				title: "Import Itinerary from AwardWallet",
				buttons: [],
				onClose
			},
			dd.p(null,
				"Would you like to import ", dd.b(null, incomingPlanToSummaryMessage(incoming_plan.data)), " item(s) to your event?"
			),
			dd.p(null,
				dd.label({style: {fontWeight: "normal"}},
					dd.input({type: "checkbox", checked: this.state.clear_current, onChange: this.__onChange}), " Overwrite my current", dd.b(null, incomingPlanToOverwriteMessage(incoming_plan.data)), " itinerary"
				)
			),
			dd.div({className: "text-center"},
				dd.button({className: "btn btn-primary", onClick: this.__applyIncomingPlan}, "Yes"),
				" ",
				dd.button({className: "btn btn-default", onClick: onClose}, "No")
			)
		);
	}
});

module.exports = dd.createClass({
	mixins: [FormMixin, RadioServiceMixin],
	getInitialState() {
		return {
			selected_trip: null
		};
	},
	RadioService_setup() {
		return {
			AwardWallet_get_list: {
				key() {
					return 1;
				}
			}
		};
	},
	componentDidMount(){
		radio("AwardWallet_get_list").broadcast({
			eid: this.props.event.eid,
			start_date: dateformat(this.props.event.starttime, 'yyyy-mm-dd'),
			end_date: dateformat(this.props.event.stoptime, 'yyyy-mm-dd')
		});
	},
	getInitialValuesSourceVersion(props){
		return esUtils.getEventVersionIdentifier(props.event);
	},
	getInitialValues(props){
		return {
			id: props.event.id
		};
	},
	buildSchema(){
		let {event} = this.props;
		let aw_list = this.state.AwardWallet_get_list.data;

		return {
			id: {
				label: "Copy from AwardWallet",
				type: "select",
				placeholder: "---",
				options: _.object(_.filter(_.flatten(_.map(aw_list, function(list, sid){
					return _.includes(event.sids, esUtils.toInt(sid)) ? _.map(_.filter(list, "id"), function(l){
						return [l.id, l.description];
					}) : null;
				})))),
				validate: FormUtils.v.required
			}
		};
	},
	onFormChanged(field_path, new_value){
		let aw_list = this.state.AwardWallet_get_list.data;
		let tripid = new_value;

		let sid = _.first(_.filter(_.map(aw_list, function(list, sid){
			return _.includes(_.map(list, "id"), tripid) ? sid : null;
		})));

		let trip = _.first(_.filter(_.get(aw_list, [sid]), (item) => (_.get(item, ["id"]) === tripid)));

		if(sid > 0 && trip){
			this.setState({selected_trip: trip});
			// build the trip from the list data

		}
	},
	__cancelIncomingPlan: esUtils.wrapPreventDefault(function(){
		this.setState({selected_trip: null});
	}),
	render(){
		let {event, Displaylists} = this.props;
		let fields = this.Form_buildSchema();
		let data = this.state.data || {};
		let selected_trip = this.state.selected_trip;

		let ajax_list = this.state.AwardWallet_get_list;

		let name_by_sid = _.object(_.map(Displaylists && Displaylists.perspeaker, function(spkr){
			return [spkr.sid, spkr.name_full];
		}));

		let fails_by_sid = _.object(_.filter(_.map(ajax_list.data, function(list, sid){
			return _.includes(event.sids, esUtils.toInt(sid)) ? [sid, _.filter(_.map(list, "failed"))] : null;
		}), function(pair){
			return _.isArray(pair) && pair[1].length > 0;
		}));

		return dd.div(null,
			ErrorAlert({message: ajax_list.error}),
			//we need to check the _value_, not the _options_

			dd.form({className: "form-horizontal", onSubmit: this.Form_onSubmit},
				dd.div({className: "pull-right", style: {width: 245}},
					this.Form_buildInput(fields.id)
				),
				dd.label({className: "text-muted", style: {fontWeight: "normal", marginTop: 6, marginRight: 5}}, fields.id.label),
				dd.div({className: "clearfix"})
			),

			_.map(fails_by_sid, function(fails, sid){
				return dd.div({key: sid, className: "text-warning"},
					_.map(fails, function(fail, i){
						return dd.div({key: i}, fail + " (" + name_by_sid[sid] + ")");
					})
				);
			}),

			// Sits under the "To grab trips, first connect to your AwardWallet
			// account..." warning above, which is where someone who has not hooked
			// up AwardWallet yet ends up looking.
			dd.div({className: "small", style: {marginBottom: 10}},
				dd.a({href: "https://www.espeakers.com/kb/managing-event-travel", target: "_blank"},
					"Learn more about AwardWallet and how to connect it to your account.",
					dd.i({style: {marginLeft: "0.5em"}, className: "fa fa-external-link"})
				)
			),

			ajax_list.waiting ? dd.span(null, dd.i({className: "fa fa-spinner fa-spin"}), " Pulling details from AwardWallet...") : null,

			selected_trip ? ApplyIncomingPlan({
				event: event,
				onClose: this.__cancelIncomingPlan,
				incoming_plan: selected_trip,
				id: data.id
			}) : null
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/travel/AwardWallet.js